<template>
  <div class="cpt-room-info-scroll-item-wrapper cpt-use-setting">
    <div class="room-info-title text-tx-1 text-[14px] font-bold leading-[normal] mb-[20px]">房间资料</div>
    <div class="room-info module" :class="{'no-event': showRoomInfoMask}">
      <div
        class="audit-state-bar py-[6px] px-[12px] flex-items-center justify-between rounded-t-[8px]"
        :class="[isRoomMaskApplying ? 'bg-fl-cb' : 'bg-er-fl']"
        v-if="showRoomInfoMask"
      >
        <div class="audio-state-left flex-items-center gap-[6px]">
          <i class="iconfont icon-toast-warn w-[16px] h-[16px] text-[16px] text-tx-1" />
          <span class="flex-[1_0_0] overflow-hidden text-op-5 text-ellipsis text-[12px] leading-[18px]">{{ isRoomMaskApplying ? '房间资料修改审核中' : '审核未通过' }}</span>
        </div>
        <div class="audit-state-right h-[24px] min-w-[46px] flex-center bg-op-1 px-[9px] py-0 text-op-5 text-center text-[12px] leading-[16px] pointer" @click="changeApplyStatus">
          {{ isRoomMaskApplying ? '撤销申请' : '我知道了' }}
        </div>
      </div>
      <div 
        class="w-[546px] h-[495px] self-stretch rounded-b-[8px] bg-op-1 p-5"
        :class="[showRoomInfoMask ? 'rounded-t-[0px] opacity-40' : 'rounded-t-[8px]']"
        v-delegate="{
          click: {
            'edit': {
              handler: showEditDialog
            }
          }
        }"
      >
        <div class="info-block flex gap-5">
          <div class="left-info w-[295px] flex flex-col self-stretch">
            <div class="row w-full flex-btw self-stretch" data-delegate-edit>
              <div class="row-left-label">房间名称</div>
              <div class="row-right-name max-w-[166px] ellipsis text-tx-2 text-[14px] leading-[18px]">{{ showRoomInfo.room_name }}</div>
            </div>
            <div class="divider"></div>
            <div class="row w-full flex-btw self-stretch" data-delegate-edit>
              <div class="row-left-label">房间头像</div>
              <ChatRoomAvatar 
                :width="34" 
                :height="34" 
                :radius='5' 
                :keep_active="true" 
                :img="showRoomInfo.room_avatar" 
                :room_name="showRoomInfo.room_name"
                :chat_img_props="{gif_active_type: 'focus'}"
              />
            </div>
            <div class="divider"></div>
            <div class="row w-full flex-btw self-stretch" data-delegate-edit>
              <div class="row-left-label">房间横幅</div>
              <div class="flex-center w-[69px] h-[34px] rounded-[5px]">
                <ChatImg :src="showRoomInfo.room_pic_url || showRoomInfo.room_pic || DEFAULT_ROOM_BG"></ChatImg>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row flex-col w-full flex-btw self-stretch mt-[8px]" data-delegate-edit>
              <div class="row-left-label w-full">房间简介</div>
              <div 
                class="h-[69px] ellipsis-3 self-stretch text-[14px] leading-[24px] tracking-[0.56px] mt-[6px] mb-[8px] text-tx-2 break-all"
                v-emoji-html="{text: showRoomInfo.introduction || '暂无简介'}"
              >
              </div>
            </div>
            <div class="divider"></div>
            <div class="row flex-col w-full flex-btw self-stretch mt-[8px]">
              <div class="row-left-label w-full">房间背景</div>
              <div class="row-bottom-bg group/wrapper pointer relative w-[204px] h-[116px] rounded-[5px] mt-[6px] self-start">
                <ChatImg
                  class="absolute top-0 left-0 wh-full object-cover rounded-[5px]"
                  v-if="showRoomInfo.bg_pic" 
                  :src="showRoomInfo.bg_pic"
                  :webp_quality="50" 
                  :thumbnail="`460x`"
                />
                <div
                  v-else
                  class="gradient-bg absolute inset-0 object-cover rounded-[5px]"
                  :style="getBackgroundColor"
                  >
                </div>
                <div
                  v-if="!canDecorate"
                  @click="showRoomLevelDialog"
                  class="w-[200px] h-[30px] absolute top-[0] px-[10px] z-20 bg-fl-sl text-bd-tx text-[12px] leading-[30px] text-center">
                  完成任务解锁
                </div>
                <div
                  class="invisible group-hover/wrapper:visible bg-black/70 absolute inset-0 flex-center text-wh-5 text-[12px] font-bold leading-[16px]"
                  :class="[!canDecorate ? 'top-[30px] rounded-bl-[5px] rounded-br-[5px]' : 'rounded-[5px]']"
                  @click="customTheme"
                >
                  {{ !canDecorate ? '自定义预览' : '自定义设置' }}
                </div>
              </div>
            </div>
          </div>
          <div class="right-preview w-[191px]">
            <div class="sub-title" style="line-height: 16px;">预览区</div>
            <div class="room-card h-[239px] relative rounded-[8px] bg-fl-3">
              <div class="bg-img-wrapper flex-center h-[115px] w-full rounded-t-[8px] overflow-hidden relative">
                <ChatImg
                  :src="showRoomInfo.room_pic_url || showRoomInfo.room_pic || DEFAULT_ROOM_BG"
                  :webp_quality="30"
                  :thumbnail="`480x`"
                />
                <div class="bg-mask"></div>
              </div>
              <div class="absolute top-[73px] left-[16px] right-[16px] bottom-[14px] overflow-hidden flex flex-col">
                <ChatRoomAvatar
                  :img="showRoomInfo.room_avatar_url || showRoomInfo.room_avatar"
                  :room_name="showRoomInfo.room_name"
                  :icon_width="24"
                  :width="50"
                  :keep_active="true"
                  :webp_quality="30"
                  :chat_img_props="{gif_active_type: 'focus'}"
                />
                <div
                  class="room-bind-games"
                  v-if="showRoomInfo.bind_game_infos && showRoomInfo.bind_game_infos.length"
                >
                  <ChatImg
                    v-for="game in showRoomInfo.bind_game_infos.filter(
                      (bind) => bind && bind.pic_url && bind.appid
                    )"
                    :key="game.appid"
                    v-tooltip="{ text: game.name }"
                    :src="game.pic_url"
                    :webp_quality="30"
                  />
                </div>
                <div class="room-name flex-items-center w-full h-[20px] mt-[10px] leading-[18px]">
                  <ChatImg
                    v-if="showRoomInfo.room_icon?.length > 0"
                    v-tooltip="{ text: showRoomInfo.room_icon[0].desc }"
                    :src="showRoomInfo.room_icon[0].icon"
                    :webp_quality="50"
                    :thumbnail="`48x`"
                    class="flex-shrink-0"
                  />
                  <span class="text-[14px] font-bold ellipsis text-tx-1" v-emoji-html="{text: showRoomInfo.room_name}"></span>
                </div>

                <div 
                  class="mt-[6px] text-op-4 text-[12px] leading-[20px] ellipsis-2 break-all"
                  v-emoji-html="{text: showRoomInfo.introduction, className: 'w-[14px]'}"
                >
                </div>
                <div class="bottom-info">
                  <div class="online-num">
                    <div class="green-ball"></div>
                    <span class="online-info">在线人数</span>
                  </div>
                  <div class="member-num">
                    <i class="iconfont icon-friends"></i>
                    <span>成员数</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Button style="margin-top: 20px; height: 42px; border-radius: 5px;" data-delegate-edit text="编辑房间资料"></Button>
      </div>
    </div>
    <div class="module-divider"></div>
    <div class="room-privacy module">
      <div class="public-block">
        <div class="self-stretch text-tx-1 text-[14px] font-bold leading-[normal] my-[20px]">房间信息</div>
        <div class="pointer-wrapper column" :class="{'permission-disable': isDisabled}" style="padding-top: 0; border-radius: 12px;">
          <div class="flex-items-center py-[15px] px-[12px] self-stretch bg-fl-3 rounded-t-[12px]">
            <i class="iconfont icon-horn text-wn-tx self-start mt-[4px]"></i>
            <div class="room-type-info flex-1 ml-[6px]">
              <div class="text-tx-2 text-[14px] leading-[24px]">
                {{ roomTypeText }}
              </div>
              <div class="text-ol-tx text-[14px] leading-[24px]">
                鼓励房间成员语音、发送文字消息、在线，将有助于提高房间在首页的排名
              </div>
            </div>
          </div>
          <div class="between" @click="showBindGameDialog(false)" v-if="isPublic">
            <p class="left item-center"><span class="name" style='margin-bottom: 0;'>常玩游戏标签</span></p>
            <div class="room-bind-game">
              <template v-for="game in showGameInfo.slice(0, realBindGames.length > 3 ? 2 : 3 )" >
                <ChatImg v-if="game.pic_url && game.appid" :key="game.appid" :src="game.pic_url"></ChatImg>
              </template>
              <div
                v-if="isOfficial && realBindGames.length > 3"
                class="bind-game-ellipse"
              > 
                +{{ realBindGames.length - 2 }}
              </div>
              <span>设置标签</span>
              <i class="iconfont icon-arrow-left"></i>
              <div 
                class="white-tip" 
                style="width: 230px;"
                v-if="form.showTipBindGame === 'room-setting-show'"
              >设置游戏标签，吸引更多游戏爱好者加入</div>
            </div>
          </div>
          <div class="between" @click="showBindGameDialog(true)" v-if="isPublic && isOfficial">
            <p class="left"><span class="name">相似游戏标签</span></p>
            <div class="room-bind-game">
              <template v-for="game in roomInfo.room_setting.similar_game_infos" >
                <ChatImg v-if="game.pic_url && game.appid" :key="game.appid" :src="game.pic_url"></ChatImg>
              </template>
              <span>设置标签</span>
              <i class="iconfont icon-arrow-left"></i>
              <div 
                class="white-tip" 
                style="width: 230px;"
                v-if="form.showTipBindGame === 'room-setting-show'"
              >设置游戏标签，吸引更多游戏爱好者加入</div>
            </div>
          </div>
          <div
            class="rounded-[12px] mt-[10px] mb-[15px] mx-[12px] w-[522px] bg-bg-ln-3"
            v-if="advantageList && advantageList.length"
          >
            <div
              v-if="!isPublic"
              class="flex-items-center gap-[4px] self-stretch px-[12px] py-[15px]"
              @click="handleCustomizedRoomID"
              >
              <div class="flex-items-center flex-1 text-wh-0 text-[14px] font-bold leading-[normal]">
                {{ '公开房间' }}
              </div>
              <div class="advantage-row-operation">
                <el-switch :value="isPublic" style="width: 39px; height: 24px;"></el-switch>
              </div>
            </div>
            <div
              v-else-if="!isHotRoom"
              class="flex-items-center gap-[4px] self-stretch px-[12px] py-[15px]"
              @click="checkApplyQualify"
            >
              <div class="flex-items-center flex-1 text-wh-0 text-[14px] font-bold leading-[normal]">
                {{ '申请成为热门房间'}}
              </div>
              <div class="advantage-row-operation">
                <Button text="申请"></Button>
              </div>
            </div>
            <div class="wh-full flex flex-col gap-[10px] rounded-b-[12px] px-[20px] py-[12px] bg-op-s2">
              <div class="self-stretch text-wh-4 text-[13px] not-italic font-normal leading-[18px]">
                成为{{ !isPublic ? '公开房间' : '热门房间' }}后将获得以下优势：
              </div>
              <div class="flex flex-col flex-wrap self-stretch px-0 py-0 gap-[10px]">
                <div class="w-full flex items-start gap-[4px]" v-for="(advantage, index) in advantageList" :key="index">
                  <div class="left h-[20px] flex-center">
                    <i class="iconfont text-wh-0 !text-[14px]" :class="[`icon-${advantage.icon}`]"></i>
                  </div>
                  <div class="right text-wh-0 text-[14px] leading-[normal]">
                    {{ advantage.title }}{{ advantage.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="between" v-if="isPublic" @click="handleCustomizedRoomID()" :class="{'permission-disable': isHotRoom}">
            <div class="left column">
              <div class="name">公开房间</div>
            </div>
            <div class="right">
              <el-switch :value="isPublic" style="height:16px;width:26px;"></el-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="module-divider"></div>
      <div class="text-tx-1 text-[14px] font-bold leading-[normal] mt-[20px]">房间等级</div>
      <div class="flex">
        <div
          class="room-level-info flex flex-1 mt-[20px] relative"
          :class="{'pl-[40px]': !noLevelProgressBar}"
        >
          <div class="absolute left-0 top-[17px] h-[60%] w-[28px]" v-if="!noLevelProgressBar">
            <div class="absolute top-0 left-1/2 h-full w-[4px] -translate-x-1/2 bg-ln-1">
              <div
                class="absolute left-0 top-0 bottom-0 w-[4px] bg-bd-tx rounded-b-[4px]"
                :class="{'no-border': levelProgress >= 99.5}"
                :style="{ height: levelProgress + '%' }"
              ></div>
            </div>
            <div class="h-full flex-col-btw">
              <div
                class="level-item flex-center"
                :class="{'on': now_room_tasks.room_level >= level.room_level}"
                v-for="level in showRoomLevelList"
                :key="'level-progress' + level.room_level"
              >
                <div class="level-num">
                  {{ level.room_level }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1">
            <div
              class="level-rewards"
              v-for="level in showRoomLevelList"
              :key="'level-rewards' + level.room_level"
              :class="{'disable': now_room_tasks.room_level < level.room_level}"
              @click="showRoomLevelDetail"
            >
              <div class="state" v-if="now_room_tasks.room_level >= level.room_level">当前等级</div>
              <div class="level-title">等级 {{ level.room_level }}</div>
              <div class="level-require" v-html="level.task_desc"></div>
              <div class="rewards-list" :class="{'show-mg': level.rights.length > 2}">
                <div class="rewards-item" v-for="rewards in level.rights" :key="rewards.desc">
                  <i class="iconfont" :class="rewards.icon" v-if="rewards.icon"></i>
                  <div class="rewards-desc" v-html="rewards.desc"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-divider"></div>
    <div class="room-privacy module" style="margin-bottom: 0;" v-if="!isDisabled">
      <div class="self-stretch text-tx-1 text-[14px] font-bold leading-[normal] my-[20px]">房间主题</div>
      <div class="room-theme-wrapper">
        <div @click="handleShowThemeEditDialog" class="between" :class="{'permission-disable': isDisabled || themeUpdateSecond}">
          <div class="left column">
            <div class="name">
              游戏主题
              <span class="theme-edit-countdown">(7天内仅支持修改一次{{ themeUpdateSecond ? `，还剩 ${themeCountdown}` : ''}})</span>
            </div>
            <div class="desc">成员将按对应 游戏段位 分组，展示游戏ID、战绩</div>
          </div>
          <div class="right" v-if="roomThemes.length">
            <div class="game-select-input">
              <ChatImg v-if="activeTheme.pic_url" :src="activeTheme.pic_url" :webp_quality="50" :thumbnail="`48x`"/>
              <span >{{activeTheme.name}}</span>
              <i class="iconfont icon-arrow-left"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="room-theme-detail" v-if="activeTheme.name && activeTheme.appid" :class="{'disable': !activeTheme.name}">
        <div v-if="activeTheme.name !== '魔兽世界'" class="theme-detail pointer-wrapper between" @click="setGameSwitch('show_game_name')" :class="{'disabled': gameNameUpdateSecond}">
          <p>
            房间昵称展示成员的 {{ activeTheme.name }} ID
            <span class="theme-edit-countdown">(1天内仅支持修改一次{{ gameNameCountdown ? `，还剩 ${gameNameCountdown}` : ''}})</span>
          </p>
          <el-switch
            v-model="game_theme_config.show_game_name"
            style="height:16px;width:26px;"
            :disabled="gameNameUpdateSecond > 0"
            @change="handleGameNameChange"
          >
          </el-switch>
        </div>
        <div class="theme-detail pointer-wrapper between" @click="setGameSwitch('show_game_card')">
          <p>成员资料卡展示 {{ activeTheme.name }} 战绩</p>
          <el-switch @click.native="setGameSwitch('show_game_card')" v-model="game_theme_config.show_game_card" style="height:16px;width:26px;"></el-switch>
        </div>
        <div class="theme-detail pointer-wrapper between" @click="setGameSwitch('group_by_role')">
          <p>成员按 {{ activeTheme.name }} 段位分组展示</p>
          <el-switch @click.native="setGameSwitch('group_by_role')" v-model="game_theme_config.group_by_role" style="height:16px;width:26px;"></el-switch>
        </div>
      </div>
    </div> 
    <RoomTeamSetting
      v-if="initedTextChannelList"
      :textChannelList="textChannelList"
      :matchChannelList="channelGroupList"
      :roomInfo="roomInfo"
      :channels="channels"
    />
    <template v-if="isCanUseFeedback && initedTextChannelList">
      <div class="module-divider"></div>
      <!-- 反馈频道 -->
      <FeedbackChannel
        :textChannelList="textChannelList"
        :roomInfo="roomInfo"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import EventBus from "_lib/EventBus";
import FeedbackChannel from './RoomInfo/FeedbackChannel.vue';
import RoomTeamSetting from './RoomInfo/RoomTeamSetting.vue';

import { 
  checkApplyForHot,
  setRoomCustomizedID,
  getRoomGameThemes,
  editRoomGameTheme,
  cancelHotRoomApplying,
  readHotRoomApplyingInfo,
} from "_api/room/index";
import { reportData } from "_api/report";
import { copyText, deepCopy, formatLeftTime } from "_lib/utils/utils";

import { HEYGIRL_ADD_COMMUNITY } from '../setting-config';
import { ROOM_EDIT_APPLY_STATE, APPLY_HOT_STATUS, ROOM_ICON_ID_MAP, DEFAULT_ROOM_BG } from '@/common/constants/room';
import { getChannelIcon, STATIC_CHANNEL_ID } from "_lib/constants/channel";
import { CHANNEL_TYPES } from '@/common/constants/channel';
import { filterHideChannel } from '@/views/room/utils';
import { getSparkRoomLevel, ROOM_SPARK_LEVEL } from '_lib/constants/spark';
import { ROOM_MEMBER_COUNT_LIMIT } from '_lib/constants/room'
import { ROLE_TYPES } from '_lib/constants/role';
import ChannelSelector from '_com/busy/channelSelector';


export default {
  name: 'RoomInfo',
  props: ['form', 'show', 'channels'],
  components: {
    FeedbackChannel,
    RoomTeamSetting,
    ChannelSelector,
  },
  data() {
    return {
      room: {},
      HEYGIRL_ADD_COMMUNITY,
      applyConditions: [],
      game_theme: {},
      game_theme_config: {
        theme_id: 0,
        show_game_name: true,
        show_game_card: true,
        group_by_role: true,
      },
      
      roomThemes: [],
      roomThemeKey: 0,
      APPLY_HOT_STATUS,
      original_avatar: '',
      activeTheme: {},
      // 关联组队的相关信息
      // 同步 关联游戏 的组队贴到 关联频道
      // 将组队工具中关联的
      
      textChannelList: [],
      channelGroupList: [],
      themeCountdown: '',
      themeUpdateSecond: 0,
      themeCountdownTimer: null,

      gameNameCountdown: '',
      gameNameUpdateSecond: 0,
      gameNameCountdownTimer: null,
      DEFAULT_ROOM_BG,
      initedTextChannelList: false,
      CHANNEL_TYPES,
      is_init_channel: false,
    }
  },
  computed: {
    ...mapGetters([
      "cur_room_data", 
      'channel_connecting', 
      'cur_room_whole_data',
      'global_config',
      'cur_roles_list',
      'cur_text_channel_data',
      'guidance_channel_list',
    ]),
    roomInfo() {
      return this.form.room || {}
    },
    isPublic () {
      return !!this.roomInfo.is_public
    },
    PublicID() {
      return this.roomInfo.public_id
    },
    isCurrentRoom() {
      return this.cur_room_data.room_id === this.roomInfo.room_id
    },
    isDisabled () {
      return !this.$permission.judge('RoomManager');
    },
    canDecorate () {
      return this.cur_room_data.can_decorate
    },
    showRoomInfo () {
      if(this.form.hot_apply_info && this.form.hot_apply_info.apply_status != ROOM_EDIT_APPLY_STATE.not_apply) {
        return {
          ...this.form.hot_apply_info,
          room_avatar: this.form.hot_apply_info.avatar,
        }
      } else {
        return this.roomInfo
      }
    },
    isCanUseFeedback(){
      const canUseTeamToolIdList = [ROOM_ICON_ID_MAP['heybox-official'], ROOM_ICON_ID_MAP['game-official']]
      return this.roomInfo.room_setting?.room_icon_id?.some(id => canUseTeamToolIdList.includes(id))
    },
    isOfficial(){
      const officials = [ROOM_ICON_ID_MAP['game-official']]
      const icons = this.roomInfo.room_icon || []
      return icons.some(item => officials.includes(item.room_icon_id))
    },
    showGameInfo(){
      if(!this.roomInfo || !this.roomInfo.room_setting || !this.roomInfo.room_setting.bind_game_infos) return []
      return this.roomInfo.room_setting.bind_game_infos
    },
    realBindGames(){
      if(!this.roomInfo || !this.roomInfo.room_setting) return []
      const realBindGames = this.roomInfo.room_setting.bind_game_infos?.filter(item => item.appid) || []
      return realBindGames
    },
    isHotRoom() {
      return !!this.roomInfo.is_hot
    },
    roomTypeText() {
      if(this.isPublic) {
        if(this.isHotRoom) {
          return `当前房间类型: 热门房间 (上限 ${this.global_config.hot_room_member_limit || ROOM_MEMBER_COUNT_LIMIT.HOT} 人), 将展示在黑盒语音首页`
        } else {
          return `当前房间类型: 公开房间 (上限 ${this.global_config.public_room_member_limit || ROOM_MEMBER_COUNT_LIMIT.PUBLIC} 人)。`
        }
      } else {
        return `当前房间类型: 私人房间 (上限 ${this.global_config.normal_room_member_limit || ROOM_MEMBER_COUNT_LIMIT.PRIVATE} 人)。`
      }
    },
    getBackgroundColor() {
      if(!this.showRoomInfo.bg_color) {
        return `background: linear-gradient(0, #1F2225 0%, #36393E 100%);`
      }
      return `background: linear-gradient(0, ${this.showRoomInfo.bg_color.split(",")[0]} 0%, ${this.showRoomInfo.bg_color.split(",")[1]} 100%);`
    },
    now_room_tasks () {
      return this.form.room?.room_task || {
        tasks: []
      }
    },
    room_level_list () {
      return this.form.room_level_list || []
    },
    levelProgress() {
      return Math.min(this.now_room_tasks.finish_rate * 100, 100)
    },
    isShowRoomLevel() {
      return !!this.form.room?.room_setting?.show_room_level
    },
    showRoomLevelList() {
      return this.room_level_list.slice(this.now_room_tasks.room_level - 1, this.now_room_tasks.room_level + 1)
    },
    noLevelProgressBar() {
      return this.showRoomLevelList.length === 1
    },
    advantageList() {
      if(!this.isPublic) {
        return this.global_config.open_room_show_config || []
      } else {
        if(this.isHotRoom) {
          return null
        } else {
          return this.global_config.hot_room_show_config || []
        }
      } 
    },
    showRoomInfoMask() {
      return this.isHotRoom && [ROOM_EDIT_APPLY_STATE.wait, ROOM_EDIT_APPLY_STATE.refuse].includes(this.applyingStatus)
    },
    isRoomMaskApplying() {
      return this.isHotRoom && this.applyingStatus === ROOM_EDIT_APPLY_STATE.wait
    },
    applyingStatus() {
      return this.form.hot_apply_info?.apply_status ?? ROOM_EDIT_APPLY_STATE.not_apply
    },
  },
  watch: {
    'show': {
      handler(v) {
        if (v) {
          this.showFlag = true
          if(this.channels.length) {
            this.initData()
          }
        }
      },
      immediate: true
    },
    
    channels: {
      handler(v, oldV) {
        // TODO 后续考虑去掉这个watch，1.39.2 修复了channels的watch，导致频繁触发initData
        if(this.is_init_channel) return;
        if(this.showFlag) {
          this.initData()
          this.is_init_channel = true
        }
      },
      deep: true
    }
  },
  mounted() {
    EventBus.$on('updateRoomInfo', this.handleUpdateRoomInfo)
  },
  beforeDestroy() {
    EventBus.$off('updateRoomInfo', this.handleUpdateRoomInfo)
    clearInterval(this.themeCountdownTimer)
    clearInterval(this.gameNameCountdownTimer)
    this.updateView()
  },
  methods: {
    async initData() {
      await this.getRoomGameThemes();
      if (this._isDestroyed) {
        return
      }
      this.game_theme = JSON.parse(JSON.stringify(this.roomInfo.room_setting?.game_theme || {}));
      this.game_theme_config.theme_id = this.game_theme.theme_id || 0
      if (this.game_theme_config.theme_id) {
        this.activeTheme = this.roomThemes.find(item => item.appid == this.game_theme_config.theme_id) || {}
        this.game_theme_config.show_game_name = !!this.game_theme.show_game_name
        this.game_theme_config.show_game_card = !!this.game_theme.show_game_card
        this.game_theme_config.group_by_role = !!this.game_theme.group_by_role
      } else {
        // 无主题
        this.activeTheme = this.roomThemes.find(item => item.appid === 0) || {}
      }
      // 下次能修改主题的时间戳
      const sync_time = this.game_theme.sync_time || 0
      this.themeUpdateSecond = Math.floor(sync_time - (Date.now() / 1000))
      if (sync_time && this.themeUpdateSecond > 0) {
        // 获取当时时间到update_time距离7天后的秒数
        this.initInterval()
      } else {
        this.themeUpdateSecond = 0
      }

      // 下次能修改游戏名称的时间戳
      const sync_show_game_name_time = this.game_theme.sync_show_game_name_time || 0
      this.gameNameUpdateSecond = Math.floor(sync_show_game_name_time - (Date.now() / 1000))
      if (sync_show_game_name_time && this.gameNameUpdateSecond > 0) {
        // 获取当时时间到update_time距离7天后的秒数
        this.initGameNameInterval()
      } else {
        this.gameNameUpdateSecond = 0
      }
      this.textChannelList = [{
        channel_id: '0',
        channel_name: '不关联频道'
      }]

      this.channelGroupList = []
      this.initTextChannels()
      this.initChannelGroupList()
      this.initedTextChannelList = true

      setTimeout(() => {
        this.roomThemeKey = Date.now();
      }, 500);
    },
    initTextChannels() {
      const judge = (ch) => {
        if (ch.is_private || ch.password || ch.channel_type !== CHANNEL_TYPES.text || !this.$permission.judge('ViewingChannel', ch.channel_id)) {
          return false
        }
        const everyoneRole = this.cur_roles_list.find((role) => role.type === ROLE_TYPES.everyone)
        const everyoneJudge = this.$permission.judgeRole({
          type: 'ViewingChannel',
          role: everyoneRole,
          channel_data: ch,
        }) && this.$permission.judgeRole({
          type: 'SendIM',
          role: everyoneRole,
          channel_data: ch,
        })
        if (!everyoneJudge || this.guidance_channel_list.includes(ch.channel_id)) {
          return false
        }
        return true
      }
      this.channels.forEach(item => {
        if (judge(item)) {
          this.textChannelList.push(item)
          item.icon_class = getChannelIcon(item)
        }
      })
    },
    initChannelGroupList() {
      this.channels.forEach(item => {
        if(item.channel_type === CHANNEL_TYPES.temporary_group) {
          let channel = this.channels.find(ch => ch.channel_id == item.parent_id)
          if(channel) {
            channel.icon_class = 'icon-file'
            if(this.channelGroupList.indexOf(channel) === -1) {
              this.channelGroupList.push(channel)
            }
          }
        }
      })
    },
    // filterMatchChannel(channel) {
    //   return this.channels.find(item => item.channel_id == channel.channel_id)
    // },
    
    // handleChangeMatchChannel(channel_id) {
    //   const channel = this.channelGroupList.find(item => item.channel_id == channel_id)
    //   const matching_channel = this.channels.find(item => item.channel_type == CHANNEL_TYPES.temporary_group && item.parent_id == channel.channel_id)
    //   editRoomDefaultSetting({}, {
    //     setting: 'matching_channel',
    //     room_id: this.roomInfo.room_id,
    //     value: matching_channel.channel_id
    //   }).then(res => {
    //     if (res.data.status == 'ok') {
    //       this.match_settings.channel_id = channel_id
    //     }
    //   })
    // },
    
    updateView () {
      if (this.team_update_flag) {
        EventBus.$emit('Update_room_view')
      }
    },
    handleUpdateReadStatus (val) {
      if (this.form.hot_apply_info) {
        this.form.hot_apply_info.read_status = val
      }
    },
    initInterval() {
      clearInterval(this.themeCountdownTimer)
      this.themeCountdown = formatLeftTime(this.themeUpdateSecond)
      this.themeCountdownTimer = setInterval(() => {
        this.themeUpdateSecond --
        if (this.themeUpdateSecond <= 0) {
          clearInterval(this.themeCountdownTimer)
          this.themeCountdown = ''
          this.themeUpdateSecond = 0
          return
        }
        this.themeCountdown = formatLeftTime(this.themeUpdateSecond)
      }, 1000)
    },
    initGameNameInterval() {
      clearInterval(this.gameNameCountdownTimer)
      this.gameNameCountdown = formatLeftTime(this.gameNameUpdateSecond)
      this.gameNameCountdownTimer = setInterval(() => {
        this.gameNameUpdateSecond --
        if (this.gameNameUpdateSecond <= 0) {
          clearInterval(this.gameNameCountdownTimer)
          this.gameNameCountdown = ''
          this.gameNameUpdateSecond = 0
          return
        }
        this.gameNameCountdown = formatLeftTime(this.gameNameUpdateSecond)
      }, 1000)
    },
    async getRoomGameThemes() {
      const {data} = await getRoomGameThemes({
        room_id: this.roomInfo.room_id,
        theme_id: this.game_theme_config.theme_id || ''
      })
      if (data.status == 'ok') {
        this.roomThemes = data.result.themes || []
      }
    },
    
    handleShowThemeEditDialog () {
      if (this.isDisabled || this.themeUpdateSecond) return
      EventBus.$dynamic('RoomThemeEditDialog', {
        roomThemes: this.roomThemes,
        gameNameUpdateSecond: this.gameNameUpdateSecond,
        themeConfig: JSON.parse(JSON.stringify(this.game_theme_config)),
        editCb: (config, toast_type) => {
          this.game_theme_config = config
          this.editRoomGameTheme(toast_type)
        }
      })
    },
    
    async editRoomGameTheme(toast_type = '') {
      const res = await editRoomGameTheme({}, {
        room_id: this.roomInfo.room_id,
        theme_id: this.game_theme_config.theme_id + '',
        show_game_name: this.game_theme_config.show_game_name ? 1 : 0,
        show_game_card: this.game_theme_config.show_game_card ? 1 : 0,
        group_by_role: this.game_theme_config.group_by_role ? 1 : 0,
      })
      if (res.data.status == 'ok') {
        if (toast_type) {
          this.gameNameUpdateSecond = 24 * 60 * 60 - 1
          this.initGameNameInterval()
          if (toast_type === 'theme_id') {
            this.$toast.success('游戏主题生效可能需要一定时间，请耐心等待')
            this.activeTheme = this.roomThemes.find(item => item.appid == this.game_theme_config.theme_id) || {}
            this.themeUpdateSecond = 7 * 24 * 60 * 60 - 1
            this.initInterval()
          } else if (toast_type === 'game_name') {
            this.$toast.success('游戏昵称生效可能需要一定时间，请耐心等待')
          }
        }
        
        let game_theme = this.cur_room_data.room_setting?.game_theme
        game_theme = game_theme ? JSON.parse(JSON.stringify(game_theme)) : undefined
        if (game_theme) {
          game_theme.show_game_card = this.game_theme_config.show_game_card ? 1 : 0
          this.SET_CUR_ROOM_DATA({
            game_theme
          })
        }
      }
    },
    handleGameNameChange (val) {
      this.game_theme_config.show_game_name = !val
    },
    setGameSwitch(key, is_switch = false) {
      if (!this.activeTheme.name) return
      if (key === 'show_game_name') {
        if (this.gameNameUpdateSecond) return
        this.is_confirm_name = false
        this.$query({
          config: {
            title: `确定进行修改？`,
            desc: '<span style="color: var(--f-warn-text)">该设置项一天内仅支持修改1次</span>',
            confirm: {
              text: '确定修改',
              type: 'alert'
            },
            cancel: {
              text: '取消'
            },
          },
          confirmCB: ()=> {
            this.is_confirm_name = true
            this.game_theme_config.show_game_name = !this.game_theme_config.show_game_name
            this.editRoomGameTheme('game_name')
          },
          closeCB: () => {
            if (is_switch) {
              this.game_theme_config.show_game_name = !this.game_theme_config.show_game_name
            }
          }
        })
        return
      }
      this.game_theme_config[key] = !this.game_theme_config[key]
      clearTimeout(this.edit_theme_timer)
      this.edit_theme_timer = setTimeout(() => {
        this.editRoomGameTheme()
      }, 1000);
    },
    
    showEditDialog() {
      if(this.showRoomInfoMask) return
      EventBus.$dynamic('EditRoomInfoDialog', {
        roomForm: deepCopy(this.roomInfo)
      })
    },

    handleUpdateRoomInfo(data) {
      const FIELD_NAME = 'room'
      const newData = {...this.roomInfo, ...data}
      this.$emit('updateSetting', {
        key: FIELD_NAME,
        value: newData
      })
    },

    handleCopyCustomRoomId(e) {
      let { public_id } = this.cur_room_data
      copyText(public_id)
      this.$toast.success('复制成功，向好友发送邀请链接')
    },
    // 申请热门社区
    async checkApplyQualify () {
      if (this.isDisabled) return;
      if (this.roomInfo.apply_hot_status == APPLY_HOT_STATUS.wait) return;
      const res = await checkApplyForHot({}, {room_id: this.roomInfo.room_id});
      if (res.data.status == 'ok') {
        this.applyConditions = res.data.result;
        EventBus.$dynamic('ApplyConditionDialog',{
          conditions: this.applyConditions,
          passCb: () => {
            this.handleConditionPass()
          }
        })
      }
    },
    applyHotCallback () {
      EventBus.$emit('hide-dynamic-dialog','ApplyConditionDialog')
      this.$set(this.roomInfo, 'apply_hot_status', APPLY_HOT_STATUS.wait)
      
    },

    // 改变房间ID公开状态
    handleCustomizedRoomID(enable){
      if (this.isDisabled || this.isHotRoom) return
      const { continuous_days, cumulative_days, active_members } = this.roomInfo.room_fire_flag
      const sparkLevel = getSparkRoomLevel(continuous_days, cumulative_days, active_members)
      // 如果房间有火花等级，并且不是公开房间
      if(sparkLevel !== ROOM_SPARK_LEVEL.NONE && !this.roomInfo.is_public) {
        this.$query({
          config: {
            title: `打开后房间火花将消失，是否打开`,
            confirm: {
              text: '确认',
            },
            cancel: {
              text: '取消'
            },
          },
          confirmCB: () => {
            this.sendRoomCustomizedID()
          }
        })
      } else {
        this.sendRoomCustomizedID()
      }
    },
    sendRoomCustomizedID() {
      const newIsPublic = this.roomInfo.is_public ? 0 : 1;
      setRoomCustomizedID({}, {
        is_public: newIsPublic,
        room_id: this.roomInfo.room_id
      }).then(res=>{
        this.handleUpdateRoomInfo({
          is_public: res.data.result.is_public,
          public_id: res.data.result.public_id,
        })
        if (this.isCurrentRoom) {
          const roomWholeInfo = this.cur_room_whole_data
          const channels = filterHideChannel(roomWholeInfo)
          EventBus.$emit('Channel_Room_data_Init', {
            ...roomWholeInfo, channels
          }, null, false)
          EventBus.$emit("Update_Fire_Flag", this.roomInfo)
          // 如果当前用户是公开房间转为非公开房间，并且当前用户在指南频道或者是定制频道，则让用户退出当前频道
          if (
              !newIsPublic && 
              [STATIC_CHANNEL_ID.guidance, STATIC_CHANNEL_ID.experiment].includes(this.cur_text_channel_data.channel_id)
            ) {
            this.SET_CUR_TEXT_CHANNEL_DATA({})
          }
        }
      });
    },
    async changeApplyStatus() {
      const room_id = this.roomInfo.room_id
      const isApplying = this.applyingStatus === ROOM_EDIT_APPLY_STATE.wait
      const api = isApplying ? cancelHotRoomApplying : readHotRoomApplyingInfo
      const { data: { status } } = await api({ room_id }, {})
      if (status === 'ok') {
        this.$emit('updateSetting', {
          key: "hot_apply_info",
          value: null
        })
      }
    },
    customTheme() {
      if (this.showRoomInfoMask) return
      EventBus.$emit('Show_Theme_Manager', true, {
        type: 'room',
        bg_color: this.roomInfo.bg_color,
        transparency: this.roomInfo.transparency,
        blur_rate: this.roomInfo.blur_rate,
        main_color_v2: this.roomInfo.main_color_v2,
        bar_color: this.roomInfo.bar_color,
        bg_pic: this.roomInfo.bg_pic,
        bg_pic_main_color: this.roomInfo.bg_pic_main_color,
        show_channel_bar_filter: this.roomInfo.show_channel_bar_filter,
        can_change_bg_pic: this.roomInfo.can_change_bg_pic,
      })
      EventBus.$emit('show-dynamic-component', 'room-settings', false)
    },
    showRoomLevelDialog() {
      EventBus.$emit('set_dialog_visible:RoomLevelDetail')
      reportData('click:room-level-lock', {pos: 'config'})
    },
    showBindGameDialog(isSimilar) {
      const game_infos = !isSimilar ?  this.roomInfo.room_setting.bind_game_infos : this.roomInfo.room_setting.similar_game_infos 
      EventBus.$dynamic('BindRoomGame', {
        isSimilar,
        game_infos: game_infos || [],
        room_id: this.roomInfo.room_id,
        isOfficial: this.isOfficial,
      })
      this.form.showTipBindGame = null
    },
    handleConditionPass(){
      EventBus.$dynamic('ApplyConfirmDialog', { 
        room: this.roomInfo,
        successCb: () => {
          this.applyHotCallback()
        }
      })
    },
    showRoomLevelDetail () {
      EventBus.$emit('set_dialog_visible:RoomLevelDetail')
    },
    ...mapMutations([
      'SET_CUR_ROOM_DATA',
      'SET_CUR_ROOM_WHOLE_DATA',
      'SET_CUR_TEXT_CHANNEL_DATA',
    ])
  }
}
</script>

<style lang="scss">
@import '_css/mixin.scss';
.module-divider {
  width: 546px;
  height: 1px;
  background: $d-ln-1;
  padding: 0 8px;
  margin: 20px 0;
}
.select-channel-info-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  &.perfix {
    position: relative;
    top: 7px;
    left: 8px;
  }
  &.active {
    .left-icon, .channel-name {
      color: $d-tx-1;
    }
    .group-name {
      color: $d-tx-2;
    }
  }
  .left-icon {
    font-size: 18px;
    margin-right: 6px;
    transform: none;
    color: $d-tx-4;
  }
  .channel-name {
    font-size: 14px;
    color: $d-tx-2;
    width: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .group-name {
    font-size: 12px;
    color: $d-tx-3;
    position: relative;
  }
  .radio {
    margin-left: auto;
    width: auto !important;
  }
}
.cpt-room-info-scroll-item-wrapper{
  .room-info {
    .row-left-label {
      color: $d-tx-3;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.12px;
    }
    .row-bottom-bg {
      border: 2px solid transparent;
      background-clip: padding-box;
      -webkit-background-clip: padding-box;
      &>* {
        z-index: 1;
      }
      &::after{
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 0;
        margin: -2px;
        border-radius: inherit;
        background: $d-bg-ln-3;
      }
    }
    .right-preview {
      .bg-mask {
        background: $d-bg-ln-2;
        width: 100%;
        height: 50%;
        position: absolute;
        top: 50%;
        bottom: 0px;
        left: 0px;
        right: 0px;
      }
      .room-name {
        .cpt-chat-img {
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }
      }
      .room-card {
        transition: background 0.2s ease-out;
        .bg-img-wrapper {
          transition: transform 0.2s ease-out;
        }
        .room-bind-games {
          max-width: 62px;
          height: 18px;
          position: absolute;
          top: 32px;
          right: 16px;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          border-radius: 5px;
          .cpt-chat-img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
          }
        }
        .bottom-info {
          display: flex;
          align-items: center;
          margin-top: auto;
          font-size: 12px;
          font-family: "Roboto";
          font-weight: 500;
          line-height: 16px;
          color: $d-op-4;
          .online-num {
            display: flex;
            height: 18px;
            align-items: center;
            margin-right: 8px;
            .green-ball {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: $d-ss-tx;
              margin-right: 3px;
            }
            span {
              font-size: 12px;
              line-height: 16px;
              font-weight: 500;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .online-info {
              margin-left: 1px;
              line-height: 16px;
              font-size: 12px;
              font-weight: 400;
              transform: scale(0.91);
            }
          }
          .member-num {
            display: flex;
            align-items: center;
            i {
              width: 10px;
              height: 10px;
              margin-right: 2px;
              color: $d-op-3;
              &::before {
                width: 20px;
                height: 20px;
                font-size: 20px;
                transform: scale(0.5);
                transform-origin: left top;
              }
            }
          }
        }
      }

      .channel-card {
        .menu-btn {
          @include size(30px, 30px);
          padding: 8px;
          border-radius: 4px;
          background: $ct-bl-4;
          cursor: default;
          position: absolute;
          top: 12px;
          right: 8px;
        }
        .header {
          .room-info {
            width: 100%;
            overflow: hidden;
            flex-direction: column;
            align-items: flex-start;
          }
        }
      }
    }
    .left-info {
      .divider {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2.5px;
        align-self: stretch;
        height: 1px;
        background: $d-op-1;
        padding: 0 8px;
        margin: 6px 0;
        border-radius: 5px;
      }
      .row {
        cursor: pointer;
      }
    }
    &.no-event {
      .row {
        cursor: not-allowed;
      }
    }
  }
  .advantage-row-operation {
    .el-switch {
      .el-switch__core {
        border-radius: 11px;
        background: $ct-bl-3;
        &::after {
          width: 18px;
          height: 18px;
          top: 3px;
          left: 3px;
          background: $ct-wh-3;
        }
      }
    }
    .cpt-chat-form-button {
      width: 64px;
      height: 32px;
      background: $ct-wh-0;
      border-radius: 5px;
      color: $d-bd-fl;
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.14px;
    }
  }
  .pointer-wrapper {
    &>.header{
      display: flex;
      padding: 15px 12px;
      align-items: center;
      gap: 8px;
      align-self: stretch;

      overflow: hidden;
      color: $d-tx-2;
      text-overflow: ellipsis;

      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.14px;
    }
    .team-tools-input {
      .el-select-dropdown {
        min-width: 200px !important;
      }
      .channel-info-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        &.perfix {
          position: relative;
          top: 7px;
          left: 8px;
        }
        &.active {
          .left-icon, .channel-name {
            color: $d-tx-1;
          }
          .group-name {
            color: $d-tx-2;
          }
        }
        .left-icon {
          font-size: 18px;
          margin-right: 6px;
          transform: none;
          color: $d-tx-4;
        }
        .channel-name {
          font-size: 14px;
          color: $d-tx-2;
          width: 0;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .group-name {
          font-size: 12px;
          color: $d-tx-3;
          position: relative;
        }
        .radio-item {
          margin-left: auto;
          width: auto !important;
        }
      }
    }
    .community-img {
      margin: 0 14px -9px 0;
      img {
        width: 113px;
        height: 117px;
        border-radius: 0 0 0 5px;
      }
    }
    .block {
      .title {
        margin-bottom: 8px;
      }
      .desc {
        color: $d-tx-3;
        @include tag-text($size: 12px);
        margin-bottom: 12px;
      }
      .apply-btn {
        width: 85px;
        height: 32px;
        color: $ct-wh-0;
        &.applying {
          opacity: 0.4
        }
      }
    }
  }
  
  .form-item {
    &:first-of-type {
      margin-top: 11px;
      margin-bottom: 20px;
    }
  }
  
  
  .room-bind-game {
    height: 32px;
    width: 188px;
    padding: 7px 12px;
    margin: 5px 12px;
    display: flex;
    align-items: center;
    color: $d-tx-3;
    background-color: $d-op-1;
    position: relative;
    border-radius: 4px;
    .cpt-chat-img {
      width: 22px;
      height: 22px;
      margin-right: 6px;
      border-radius: 3px;
    }
    .bind-game-ellipse {
      width: 22px;
      height: 22px;
      border-radius: 3px;
      background: $d-op-2;
      text-align: center;
      line-height: 22px;
      margin-right: 6px;
      color: $d-tx-2;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
    }
    .icon-arrow-left {
      width: 8px;
      height: 8px;
      margin-left: 5px;
      &::before {
        font-size: 16px;
        transform: scale(.5);
        transform-origin: left top;
      }
    }
    span {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      margin-right: auto;
    }
    .white-tip {
      height: auto;
      bottom: 38px;
      right: -35px;
      font-size: 14px;
      line-height: 18px;
      white-space: normal;
      text-align: left;
      pointer-events: none;
    }
  }
  .room-level-info {
    .level-item {
      width: 28px;
      height: 28px;
      position: relative;
      border-radius: 50%;
      background: $d-ln-1;
      color: $d-tx-3;
      flex-shrink: 0;
      z-index: 1;
      &.on {
        background: $d-bd-tx;
        color: $d-fl-1;
      }
      
      .level-num {
        font-family: Roboto;
        font-size: 17.5px;
        font-weight: 500;
        letter-spacing: 0.7px;
      }
    }
    .level-rewards {
      margin-bottom: 20px;
      padding-top: 20px;
      width: 100%;
      position: relative;
      border-radius: 12px;
      background: $d-bg-ln-3;
      overflow: hidden;
      cursor: pointer;
      &.disable {
        opacity: .4;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .state {
        position: absolute;
        top: 12px;
        right: -36px;
        transform: rotate(45deg);
        width: 120px;
        height: 24px;
        background: $ct-wh-4;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $ct-bl-4;
        font-size: 12px;
        line-height: 16px;
      }
      .level-title {
        padding-left: 20px;
        color: $ct-wh-0;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
      }
      .level-require {
        margin-top: 6px;
        padding-left: 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: $ct-wh-5;
        font-size: 12px;
        line-height: 16px;
        white-space: pre;
        span {
          margin: 0 2px;
          padding: 0 4px;
          min-width: 16px;
          height: 16px;
          border-radius: 8px;
          background: #9CFF8C;
          display: flex;
          justify-content: center;
          align-items: center;
          color: $ct-bl-0;
          font-family: Roboto;
          font-size: 13px;
          font-weight: 500;
          line-height: 14px;
        }
      }
      .rewards-list {
        margin-top: 16px;
        background: $d-op-s2;
        display: flex;
        flex-wrap: wrap;
        padding: 12px 20px 10px; 
        &.show-mg {
          .rewards-item { 
            margin-bottom: 10px;
          }
        }
        .rewards-item {
          width: 50%;
          display: flex;
          align-items: center;
          color: $ct-wh-0;
          .iconfont {
            margin-right: 6px;
            font-size: 16px;
          }
          .rewards-desc {
            font-size: 14px;
            line-height: 18px; 
          }
        }
      }
      
    }
  }
}
</style>